module.exports = __webpack_public_path__ + "img/bb_platform_09.86f88f1c.svg";